import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import SyncDataPopup from "../components/popup/SyncDataPopup";
import { getUserList, getUserListForManager } from "../Services/SsoService";
import { useSelector } from "react-redux";
import orgChartLogo from "../assets/images/orgchartLogo.png";

const SyncDataModalContext = createContext();

export const SyncDataModalProvider = ({ children }) => {
  const [syncDataModalOpen, setSyncDataModalOpen] = useState(false);
  const userData = useSelector((state) => state?.user?.user);
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [startDataCount, setStartDataCount] = useState(0);
  const [endDataCount, setEndDataCount] = useState(0);
  const [noOfPage, setNoOfPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [syncingLoader, setSyncingLoader] = useState(false);
  const [syncingStep, setSyncingStep] = useState({ step: "1", message: null });
  const [selectedRole, setSelectedRole] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const [selectedWebsite, setSelectedWebsite] = useState({
    _id: 1,
    name: "ORG Chart",
    image: orgChartLogo,
    code: "orgChart",
    value: "orgChart",
  });
  const token_ = localStorage.getItem("admin_accessToken");

  const adminRole = userData?.role?.find(
    (item) =>
      item?.code === "COMPANY-ADMINISTRATOR" || item?.code === "COMPANY-MANAGER"
  );
  const loadUserList = useCallback(async () => {
    setLoading(true);

    const fetchUserList = async (payload, apiCall) => {
      try {
        const result = await apiCall(payload);
        if (result.status === 200) {
          setUserList(result?.docs);
          setTotalDataCount(result?.totalDocs);
          setPageCount(result?.totalPages);
        }
      } catch (err) {
        console.error("Error fetching user list:", err.message);
      } finally {
        setLoading(false);
      }
    };

    if (
      adminRole?.code === "COMPANY-ADMINISTRATOR" ||
      adminRole?.code === "COMPANY-MANAGER"
    ) {
      const payload = {
        keyword,
        limit,
        offset,
        companyId: userData?.companyDetails?._id,
      };

      if (selectedRole?.value !== "all" && selectedRole?.name) {
        payload["roleType[0]"] = selectedRole?.name;
      }

      if (
        selectedState?.value !== "all" &&
        selectedState?.value !== undefined
      ) {
        payload["alreadySynced"] = selectedState?.value;
        payload["code"] = syncingStep?.selectedWebsite?.code;
      }

      const apiCall =
        adminRole?.code === "COMPANY-ADMINISTRATOR"
          ? getUserList
          : getUserListForManager;

      fetchUserList(payload, apiCall);
    } else {
      setLoading(false);
      setUserList([]);
    }
  }, [
    keyword,
    limit,
    offset,
    selectedRole,
    userData,
    selectedWebsite,
    adminRole,
    selectedState,
  ]);

  useEffect(() => {
    if (token_ && userData) {
      loadUserList();
    }
  }, [loadUserList]);

  return (
    <SyncDataModalContext.Provider
      value={{
        syncDataModalOpen,
        setSyncDataModalOpen,
        userList,
        setUserList,
        loadUserList,
        loading,
        setLoading,
        syncingLoader,
        setSyncingLoader,
        syncingStep,
        setSyncingStep,
        keyword,
        setKeyword,
        limit,
        setLimit,
        offset,
        setOffset,
        totalDataCount,
        setTotalDataCount,
        startDataCount,
        setStartDataCount,
        endDataCount,
        setEndDataCount,
        noOfPage,
        setNoOfPage,
        currentPage,
        setCurrentPage,
        selectedRole,
        setSelectedRole,
        setSelectedState,
        selectedState,
        pageCount,
        setPageCount,
        selectedWebsite,
        setSelectedWebsite,
      }}
    >
      {children}
      <SyncDataPopup isOpen={syncDataModalOpen} />
    </SyncDataModalContext.Provider>
  );
};

export const useDataSyncModal = () => {
  return useContext(SyncDataModalContext);
};
